<template>
  <!-- 首页顶部组件，显示基本信息，其它系统可使用组件通过slot添加功能 -->
  <div class="home-top">
    <div class="left">
      <div class="left-icon">
<!--        <image-show v-model="userInfo.merchantLogo" class="top-logo" width="auto" height="100%" :show-view="false"/>-->
        <img :src="userInfo.rootMerchant.merchantLogo || 'https://file.xyyqgj.top/10000/merchant/xy_logo-1.png'" class="top-logo" alt=""/>
      </div>
      <div class="my-name">{{ userInfo.merchantName }}</div>
<!--      <weather-component>-->
<!--        <template v-slot="{data}">{{data.city}} - {{data.realtime.temperature}} - {{data.realtime.info}} - {{data.realtime.direct}} - {{data.realtime.power}}</template>-->
<!--      </weather-component>-->
    </div>
    <div class="right">
      <slot name="left"/>
      <table-button class="item" @click="showChangePassword = true">修改密码</table-button>
      <table-button class="item" el-type="danger" @click="userEvent('logout')">退出登录</table-button>
      <slot name="right"/>

      <el-dropdown class="item" style="vertical-align: middle;line-height: 46px" trigger="click" @command="userEvent">
        <template #default>
          <div class="user-info">
            <img class="item avatar" alt="" :src="getAvatar(userInfo.iconUrl)" v-if="userInfo.iconUrl"/>
            <yq-icon v-else class="item avatar" name="element-ui_s-custom"/>
            <div class="item user-name">{{ userInfo.employeeName || userInfo.userName }}</div>
            <div class="item role-name">{{ userInfo.roleName }}</div>
            <yq-icon name="24gf-gear" class="setting-icon"/>
          </div>
        </template>
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item command="userInfo">
              <yq-icon name="element-ui_user"/>
              {{ $t("message.userInfo") }} <!-- 个人信息 -->
            </el-dropdown-item>
            <el-dropdown-item command="switchRole">
              <yq-icon name="element-ui_user"/>
              <!--              切换角色-->{{ $t("message.changeRole") }}
            </el-dropdown-item>
            <el-dropdown-item command="toFindVersion">
              <yq-icon name="element-ui_odometer"/>
              <!--              查看版本-->{{ $t("message.viewVersion") }}
            </el-dropdown-item>
            <el-dropdown-item command="toClearSession">
              <yq-icon name="element-ui_delete"/>
              <!--              清除缓存-->{{ $t("message.clearSession") }}
            </el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </div>

    <el-dialog title="修改密码" v-model="showChangePassword" width="40%">
      <el-form label-width="80px">
        <el-form-item label="旧密码">
          <el-input type="password" v-model="passwordInfo.oldPassword" show-password autocomplete="new-password"></el-input>
        </el-form-item>
        <el-form-item label="新密码">
          <el-input type="password" v-model="passwordInfo.newPassword" show-password autocomplete="new-password"></el-input>
        </el-form-item>
        <el-form-item label="确认密码">
          <el-input type="password" v-model="passwordInfo.confirmPassword" show-password autocomplete="new-password"></el-input>
        </el-form-item>
        <template #footer>
          <page-button @click="showChangePassword = false">取消</page-button>
          <page-button message="修改密码后，需要重新登录，您确认操作吗？" el-type="primary" @click="changePassword">确定</page-button>
        </template>
      </el-form>
    </el-dialog>
    <el-dialog v-model="showSwitchRole" title="切换角色" dialog-width="1">
      <el-form label-width="70px">
        <el-form-item label="职员名称">{{ editUser.employeeName || editUser.userName }}</el-form-item>
        <el-form-item label="当前机构">{{ editUser.merchantName }}</el-form-item>
        <el-form-item label="当前角色">
          <el-select v-model="editUser.roleId">
            <el-option v-for="r in editUser.roleList" :value="r.id" :label="r.roleName">
              <span class="role-info">{{ r.roleName }}</span>
              <span class="role-merchant">{{ r.merchantName }}</span>
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div style="text-align: right">
        <page-button @click="showSwitchRole = false">取消</page-button>
        <page-button el-type="primary" @click="switchRole">确认</page-button>
      </div>
    </el-dialog>

    <!-- 查看版本 -->
    <el-dialog
      v-model="showVersionDialog"
      title="版本信息"
      width="520px"
      :close-on-click-modal="false"
    >
      <div class="version-wrapper">
        <div class="version-row">
          <span class="label">应用名称</span>
          <span class="value">{{ versionInfo.appName }}</span>
        </div>
        <div class="version-row">
          <span class="label">前端版本</span>
          <span class="value">{{ versionInfo.frontVersion }}</span>
        </div>
        <div class="version-row" v-if="versionInfo.env">
          <span class="label">运行环境</span>
          <span class="value">{{ versionInfo.env }}</span>
        </div>
        <div class="version-row" v-if="versionInfo.baseApi">
          <span class="label">接口地址</span>
          <span class="value">{{ versionInfo.baseApi }}</span>
        </div>
        <div class="version-row">
          <span class="label">构建时间</span>
          <span class="value">{{ versionInfo.buildTime }}</span>
        </div>
        <div class="version-row">
          <span class="label">当前用户</span>
          <span class="value">{{ userInfo.userName }}（{{ userInfo.roleName }}）</span>
        </div>
        <div class="version-row">
          <span class="label">浏览器</span>
          <span class="value ua">{{ versionInfo.ua }}</span>
        </div>
      </div>

      <template #footer>
        <div class="dialog-footer">
          <page-button @click="copyVersion">复制</page-button>
          <page-button el-type="primary" @click="showVersionDialog = false">关闭</page-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>

import YqIcon from "@/components/YqIcon.vue";
import util from "@/util/util";
import TableButton from "@/components/h5/button/TableButton.vue";
import commonApi from "@/api/commonApi";
import ImageShow from "@/components/h5/image/ImageShow.vue";
import {useRoute, useRouter} from "vue-router";
import imageUtil from "@/util/imageUtil";
import WeatherComponent from "@/components/h5/data/WeatherComponent.vue";

export default {
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "HomeTop",
  components: {
    TableButton, YqIcon, ImageShow, WeatherComponent
  },
  data() {
    return {
      showChangePassword:false,
      userInfo: {
        rootMerchant: {}
      },
      notices: [], // 系统公告列表，从后端获取
      messageSession: null, // 消息会话，用于和后端建立ws连接
      sessionInterval: null,
      showMessageList: false, // 是否显示消息列表
      unreadCount: 0, // 未读消息数量
      passwordInfo: {},
      // 公告弹窗
      currentNotice: { id: '', title: '', content: '', level: '1', isRead: 'N' },
      showSwitchRole: false,
      editUser: {},
      // 版本信息
      showVersionDialog: false,
      versionInfo: {
        appName: '',
        frontVersion: '',
        env: '',
        baseApi: '',
        buildTime: '',
        ua: ''
      },
      loadingMessage: false,
    };
  },
  created() {
    util.getUserInfo().then(user => {
      if (!user.rootMerchant) {
        user.rootMerchant = {};
      }
      // 商户logo
      if (user.rootMerchant.merchantLogo) {
        user.merchantLogo = imageUtil.getFileUrlSingle(user.rootMerchant.merchantLogo);
      } else if (user.merchantList && user.merchantList.length > 0) {
        user.merchantLogo = imageUtil.getFileUrlSingle(user.merchantList[0].merchantLogo);
      }
      this.userInfo = user;
      // 设置浏览器的名称
      // document.title = user.rootMerchant.merchantName || user.merchantName;
    });
  },
  unmounted() {

  },
  methods: {
    // 获取头像的url
    getAvatar(avatar){
      return imageUtil.getFileUrlSingle(avatar);
    },
    async changePassword() {
      if (this.passwordInfo.newPassword.length < 6) {
        this.$message.error('密码长度不能少于6位');
        return;
      }
      await commonApi.changePasswordV2(this.passwordInfo);
      this.$message.success("修改密码成功，请重新登录！");
    },
    toSwitchRole(){
      // 切换角色
      let roleList = [...this.userInfo.roleList];
      for (let i = 0; i < roleList.length; i++) {
        for (let j = 0; j < this.userInfo.merchantList.length; j++) {
          if (roleList[i].merchantId === this.userInfo.merchantList[j].id) {
            roleList[i].merchantName = this.userInfo.merchantList[j].merchantName;
            break
          }
        }
      }
      this.editUser = {
        ...this.userInfo,
        password: "",
        roleList: roleList
      };
      this.showSwitchRole = true;
    },
    // 切换角色
    switchRole() {
      if (this.editUser.roleId === this.userInfo.roleId) {
        // 角色错误
        this.$message.error({message: "选择的角色无效"})
        return;
      }
      commonApi.switchRole(this.editUser.roleId).then((user) => {
        // 缓存登录信息
        util.setUserInfo(user);
        this.userInfo = user;
        // 清空缓存
        util.clearCacheData();
        this.showSwitchRole = false;
        this.$message.success("切换角色成功！");
        // 刷新页面
        setTimeout(() => {
          window.location.reload();
        }, 300)
      });
    },
    // 用户事件
    userEvent(command) {
      switch (command) {
        case 'userInfo': // 个人信息
          this.router.push("/sys/user/info");
          break;
        case 'switchRole':
          this.toSwitchRole()
          break;
        case 'toFindVersion':
          this.openVersionDialog();
          break;
        case 'logout': // 退出登录
          // 主动退出时清掉自动登录凭据，避免退出后又被自动登回去
          util.clearAutoLoginCredential();
          commonApi.logout().then(() => {
            this.router.push("/login");
          });
          break;
        case 'toClearSession': // 清空缓存
          util.clearCacheData();
          this.$message.success("缓存已清除！");
          setTimeout(() => {
            this.router.go(0);
          }, 500);
          break;

      }
    },
    // 打开版本信息
    openVersionDialog() {
      const pad = (n) => (n < 10 ? '0' + n : n);
      const d = new Date();
      const build = `${d.getFullYear()}-${pad(d.getMonth()+1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
      this.versionInfo = {
        appName: process.env.npm_package_name || '前端应用',
        frontVersion: process.env.npm_package_version || '1.0.0',
        env: process.env.NODE_ENV,
        baseApi: process.env.VUE_APP_BASE_API || '',
        buildTime: build,
        ua: navigator.userAgent
      };
      this.showVersionDialog = true;
    },
    // 复制版本信息
    async copyVersion() {
      const v = this.versionInfo;
      const text = `应用名称: ${v.appName}\n前端版本: ${v.frontVersion}\n运行环境: ${v.env}\n接口地址: ${v.baseApi}\n构建时间: ${v.buildTime}\n浏览器: ${v.ua}`;
      try {
        await navigator.clipboard.writeText(text);
        this.$message.success('版本信息已复制');
      } catch (e) {
        this.$message.error('复制失败');
      }
    },
  }
};
</script>

<style lang="scss" scoped>
.version-wrapper {
  .version-row {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 8px 0;

    .label {
      width: 90px;
      color: #606266;
      flex-shrink: 0;
    }
    .value {
      color: #303133;
      word-break: break-all;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
    .ua {
      -webkit-line-clamp: 3;
      line-clamp: 3;
    }
  }
}

.home-top {
  height: 56px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  color: #334155;
  overflow: hidden;
  border-bottom: 1px solid #e2e8f0;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  position: relative;

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 2px;
    //background: linear-gradient(90deg, transparent 10%, var(--el-color-primary) 50%, transparent 90%);
    //animation: breathing 2.5s ease-in-out infinite;
    //opacity: 1;
    //box-shadow: 0 0 12px rgba(64, 158, 255, 0.6),
    //0 0 20px rgba(64, 158, 255, 0.3);
  }
}

@keyframes breathing {
  0%, 100% {
    opacity: 0.3;
    box-shadow: 0 0 6px rgba(64, 158, 255, 0.3);
  }
  50% {
    opacity: 1;
    box-shadow: 0 0 12px rgba(64, 158, 255, 0.6),
                0 0 20px rgba(64, 158, 255, 0.3);
  }
}

  .left {
    display: flex;
    align-items: center;
    padding-left: 20px;
    height: 100%;
    .left-icon {
      //width: 140px;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      padding-right: 16px;
      box-sizing: border-box;
      position: relative;

      &::after {
        content: '';
        position: absolute;
        right: 0;
        top: 15px;
        bottom: 15px;
        width: 1px;
        background: linear-gradient(180deg, transparent 0%, #e2e8f0 50%, transparent 100%);
      }
    }

    .top-logo {
      height: 70%;
      width: auto;
      border-radius: 6px;
      transition: transform 0.3s ease;

      &:hover {
        transform: scale(1.05);
      }
    }

    :deep(.image-show) {
      .image-item {
        border: none;
        vertical-align: text-bottom;
      }
    }

    .my-name {
      font-size: 14px;
      font-weight: 600;
      color: #1e293b;
      padding-left: 16px;
      letter-spacing: 0.5px;
    }
  }

  .right {
    display: flex;
    align-items: center;
    margin-right: 20px;
    //gap: 12px;

    .setting-icon {
      font-size: 18px;
      color: #64748b;
      padding: 6px;
      border-radius: 6px;
      transition: all 0.2s ease;
      cursor: pointer;

      &:hover {
        color: var(--el-color-primary);
        background: #eff6ff;
      }
    }

    .item {
      &.avatar {
        color: #ffffff;
        width: 32px;
        height: 32px;
        background: linear-gradient(135deg, #409eff 0%, #337ecc 100%);
        text-align: center;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 16px;
        box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);
        transition: all 0.3s ease;

        &:hover {
          transform: scale(1.1);
          box-shadow: 0 4px 12px rgba(64, 158, 255, 0.4);
        }
      }
    }

    .role-name {
      color: #64748b;
      font-size: 12px;
      padding-left: 4px;
    }

    .user-name {
      font-size: 14px;
      font-weight: 500;
      color: #334155;
      padding-left: 8px;
    }

    .user-info {
      display: flex;
      align-items: center;
      padding: 6px 12px;
      border-radius: 8px;
      transition: all 0.2s ease;
      cursor: pointer;

      &:hover {
        background: #f1f5f9;
      }
    }
  }


:deep(.el-dropdown-menu) {
  border-radius: 10px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  border: 1px solid #e2e8f0;
  padding: 4px 0;

  .el-dropdown-menu__item {
    padding: 10px 20px;
    font-size: 14px;
    color: #475569;
    transition: all 0.2s ease;

    &:hover {
      background: #eff6ff;
      color: var(--el-color-primary);
    }
  }
}
</style>